import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Grid, Container, Image, Form, Checkbox, Icon, Header, Message } from 'semantic-ui-react';
import { Button } from 'antd';
import { loadScript } from 'helpers/cloudgate';
import loginImage from 'images/login-image.png';
import logo from 'images/loginLogo.png';
import footerLogo from 'images/footerLogo.svg';
import captainPayments from 'images/captainPayments.png';
import Dpm_logo from 'images/payments/logo_black.svg';

import channelTalkService from 'helpers/channeltalk';
import storage from 'helpers/storage';
import api from 'config';
import { safeWindowOpen } from 'helpers/pathValidator';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { LoginCertTooltipContent } from '@/containers/Landing/styles';

const propTypes = {
  handleChange: PropTypes.func,
  loginAction: PropTypes.func
};

const defaultProps = {};

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }

  async componentDidMount() {
    channelTalkService.boot({
      pluginKey: api.config.channel_tolk_plugin_key
    });
  }

  async componentWillUnmount() {
    // channelTalkService.shutdown();
  }

  handleEntSubmit = (e) => {
    if (e.key === 'Enter') {
      this.props.loginAction();
    }
  };

  // _onClick = () => {
  //   channelTalkService.boot();
  // }

  popOpen = () => {
    const uri = api.config.authAPI + '/account/find/password';
    const name = 'changePWD';
    const option = 'top=10, left=10, width=500, height=600, status=no, menubar=no, toolbar=no, resizable=no';
    const win = safeWindowOpen(uri, name, option);
    return win;
  };

  render() {
    return (
      <Grid className="login-form" verticalAlign="middle">
        <Grid.Column className="login-form-col">
          <Header>
            <img src={Dpm_logo} alt="logo" />
            <p>기업비용 통합관리를 위한 식권대장의 새로운 관리자페이지</p>
          </Header>
          <Form size="large">
            <Form.Input
              className="form-input"
              label="아이디"
              placeholder=""
              autoComplete="username"
              value={this.props.id}
              autoFocus={!this.props.idSave}
              onChange={(e) => {
                this.props.handleChange(e.target.value, 'userID');
              }}
            />
            <Form.Input
              className="form-input"
              label="비밀번호"
              placeholder=""
              autoComplete="current-password"
              autoFocus={this.props.idSave}
              type="password"
              onChange={(e) => {
                this.props.handleChange(e.target.value, 'userPWD');
              }}
              onKeyPress={this.handleEntSubmit}
            />
            <Grid className="form-group">
              <Form.Checkbox
                className="form-checkbox"
                label="아이디 기억하기"
                checked={this.props.idSave}
                onChange={this.props.idSaveCheckbox}
              />
              <Button className="login-form-button-channel" onClick={this.props.onFindPassword}>
                비밀번호를 잊으셨나요?
              </Button>
            </Grid>

            <Button
              style={{ width: '100%', textShadow: 'none' }}
              type="primary"
              color="green"
              size="large"
              loading={this.props.isDim}
              onClick={this.props.loginAction}
            >
              로그인하기
            </Button>
            <p>고객센터 1644-5047</p>
            <div className="login-form-links">
              <span
                onMouseEnter={() => {
                  this.setState({ hover: true });
                }}
                onMouseLeave={() => {
                  this.setState({ hover: false });
                }}
              >
                <ExclamationCircleOutlined style={{ marginRight: '2px' }} />
                정보보호관리체계인증(ISMS)
              </span>
              {this.state.hover && (
                <LoginCertTooltipContent>
                  <p style={{ marginBottom: 0 }}>
                    <strong>인증범위:</strong> 기업 복지 서비스 플랫폼(식권대장)(정보통신망법 제47조의7에 따른 인증의
                    특례)
                  </p>
                  <p style={{ marginBottom: 0 }}>
                    <strong>유효기간:</strong> 2026.03.18 ~ 2029.03.17
                  </p>
                </LoginCertTooltipContent>
              )}
              <span className="link-separator">|</span>
              <a href="https://sikdae.com/privacy" target="_blank" rel="noopener noreferrer">
                <strong>개인정보 처리방침</strong>
              </a>
              <span className="link-separator">|</span>
              <a href="https://sikdae.com/term" target="_blank" rel="noopener noreferrer">
                이용약관
              </a>
            </div>
          </Form>
          <div className="login-form-footer">
            <div className="login-form-footer-img">
              <Image src={footerLogo} />
            </div>
          </div>
        </Grid.Column>
      </Grid>
    );
  }
}

LoginForm.propTypes = propTypes;
LoginForm.defaultProps = defaultProps;

export default LoginForm;
